import { Bar } from "react-chartjs-2";
import "./chartSetup";
import { gridColor } from "./chartTheme";
import type { Theme } from "../theme/ThemeProvider";

interface Point {
  hour?: string;
  period?: string;
  count?: number;
}

interface Props {
  data: Point[];
  label: string;
  theme: Theme;
}

export function TimelineChart({ data, label, theme }: Props) {
  return (
    <Bar
      data={{
        labels: data.map((r) => r.hour ?? r.period ?? ""),
        datasets: [
          {
            label,
            data: data.map((r) => r.count ?? 0),
            backgroundColor: "rgba(108,99,255,0.6)",
            borderColor: "rgba(108,99,255,1)",
            borderWidth: 1,
            borderRadius: 4,
          },
        ],
      }}
      options={{
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        scales: {
          x: {
            grid: { color: gridColor(theme) },
            ticks: { color: "#6A6359", font: { size: 10 } },
          },
          y: {
            grid: { color: gridColor(theme) },
            ticks: { color: "#6A6359", font: { size: 10 } },
          },
        },
      }}
    />
  );
}
